import { Component, Input } from '@angular/core';
import { ErrorInterface } from '@shared/components/input/error/error';
import { ReplacePipe } from '@shared/pipes/replace.pipe';
import { ValidationErrors } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { DATE_FORMAT } from '@app/core/constants/date-format';

/**
 * Reusable component for displaying form validation errors.
 * It accepts an errors object and renders appropriate error messages.
 */
@Component({
  selector: 'app-input-error',
  imports: [
    ReplacePipe,
    TranslatePipe,
    DatePipe,
  ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {
  /**
   * The errors input can be either a custom ErrorInterface or Angular's ValidationErrors.
   * This property holds the validation errors to be displayed by the component.
   */
  @Input() public errors?: ErrorInterface | ValidationErrors;
  protected readonly DATE_FORMAT = DATE_FORMAT;
}
